import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
export const PageHeaderContext = createContext({
    breadcrumbItems: [],
    mainAction: {},
    setBreadcrumbItems: () => { },
    setMainAction: () => { },
    setTabs: () => { },
    setTitle: () => { },
    setTranslationActions: () => { },
    tabs: [],
    title: '',
    translationActions: {},
});
export const PageHeaderContextProvider = ({ children, initialBreadcrumbItems, initialMainAction, initialTabs, initialTitle, initialTranslationActions, }) => {
    const [title, setTitle] = useState(() => initialTitle || '');
    const [breadcrumbItems, setBreadcrumbItems] = useState(() => initialBreadcrumbItems || []);
    const [tabs, setTabs] = useState(() => initialTabs || []);
    const [translationActions, setTranslationActions] = useState(() => initialTranslationActions || {});
    const [mainAction, setMainAction] = useState(() => initialMainAction || {});
    useEffect(() => {
        if (initialTabs) {
            setTabs(initialTabs);
        }
    }, [initialTabs]);
    const value = useMemo(() => ({
        breadcrumbItems,
        mainAction,
        setBreadcrumbItems,
        setMainAction,
        setTabs,
        setTitle,
        setTranslationActions,
        tabs,
        title,
        translationActions,
    }), [breadcrumbItems, mainAction, tabs, title, translationActions]);
    return (_jsx(PageHeaderContext.Provider, { value: value, children: children }));
};
export const usePageHeaderContext = () => useContext(PageHeaderContext);
//# sourceMappingURL=PageHeaderContext.js.map